import { tw } from '@/utils/tw';
import BaseAccordionTheme from 'base/components/Accordion/theme';

const Icon = tw.theme({
  extend: BaseAccordionTheme.Icon,
});

const Accordion = tw.theme({
  extend: BaseAccordionTheme,
  slots: {
    group: `sm:pr-4`,
  },
});

export default Object.assign(Accordion, { Icon });
